import React from 'react';
import PropTypes from 'prop-types';
import { Container } from 'react-bootstrap';
import OMIContent from './OMIContent';

const propTypes = {
  alert: PropTypes.node,
  id: PropTypes.string,
  facilityId: PropTypes.string,
  companyId: PropTypes.string,
  reservationId: PropTypes.string,
  unitId: PropTypes.string,
  softwareProvider: PropTypes.string,
  baseUrl: PropTypes.string,
};

const defaultProps = {
  alert: undefined,
  id: undefined,
  companyId: undefined,
  facilityId: undefined,
  reservationId: undefined,
  unitId: undefined,
  softwareProvider: undefined,
  baseUrl: undefined,
};

const OMIWidget = ({
  alert,
  id,
  facilityId,
  companyId,
  reservationId,
  unitId,
  softwareProvider,
  baseUrl,
}) => (
  <>
        <Container>
            {alert && alert}
        </Container>
        <div
          style={{ width: '100%' }}
          className="pb-no-click"
        >
            <OMIContent
              key={id}
              style={{ width: '100%' }}
              facilityId={facilityId}
              companyId={companyId}
              reservationId={reservationId}
              unitId={unitId}
              softwareProvider={softwareProvider}
              baseUrl={baseUrl}
            />
        </div>
  </>
);

OMIWidget.propTypes = propTypes;
OMIWidget.defaultProps = defaultProps;

export default OMIWidget;
